import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { stringBreakLine, formatDateToMM, decryptData } from "utils";

function Invoice(props) {
  const [billingInfo, setBillingInfo] = useState({});
  const [ccDetails, setCCDetails] = useState({});
  const [first, setFirst] = useState(false);
  useEffect(() => {
    const billingId = props.location.search.split("&")[0].split("=")[1];
    const firstPara = props.location.search.split("&")[1].split("=")[1];
    const billingInfo = JSON.parse(
      decryptData(localStorage.getItem("billing"))
    );

    const ccDetails = JSON.parse(
      decryptData(localStorage.getItem("ccDetails"))
    );
    if (billingInfo) {
      let billInfo = billingInfo.find(val => val.id == billingId);
      if (billInfo) {
        setBillingInfo(billInfo);
        setCCDetails(ccDetails);
      } else setBillingInfo("out");
    } else {
      setBillingInfo("out");
    }
    if (firstPara === "1") setFirst(true);
  }, []);

  useEffect(() => {
    if (!props.plans.loading) {
      const planDescription =
        billingInfo.transactionType === "upgrade"
          ? [
              billingInfo.comments.split("Changed to ")[1].split(" ")[0],
              billingInfo.comments.split("yearly from ")[1].split(" ")[0]
            ]
          : billingInfo.transactionType === "yearly"
          ? [billingInfo.comments.split("Charge for ")[1].split(" ")[0]]
          : billingInfo.transactionType === "subscription"
          ? [billingInfo.comments.split("Subscription to ")[1].split(" ")[0]]
          : [""];

      const modifiedBillingComments =
        planDescription.length === 1 && planDescription[0] !== ""
          ? billingInfo.comments.replace(
              planDescription[0],
              props.plans.data.plans.find(v => v.id === +planDescription[0])
                .description
            )
          : planDescription.length === 2
          ? billingInfo.comments
              .replace(
                planDescription[0],
                props.plans.data.plans.find(v => v.id === +planDescription[0])
                  .description
              )
              .replace(
                planDescription[1],
                props.plans.data.plans.find(v => v.id === +planDescription[1])
                  .description
              )
          : billingInfo.comments;
      setBillingInfo({ ...billingInfo, comments: modifiedBillingComments });
    }
  }, [props.plans]);
  if (billingInfo === "out") {
    return <Redirect to="/mirror/account" />;
  }

  return (
    <div className="invoice billing">
      <div className="billing_head">
        <div className="logo">
          <div className="icon">
            <img src="https://www.idrivemirror.com/webapp/images/blue_mirror_logo.svg" />
          </div>
        </div>
        <div className="billing_history">
          <div className="header_title">Invoice</div>
          <div className="print_transaction_summary">
            <a className="print" onClick={() => window.print()}>
              <span className="pts_icon" />
              <span className="pts_title">Print</span>
            </a>
          </div>
        </div>
      </div>
      <div className="invoice_mirror_address">
        <p>
          IDrive Inc.
          <br />
          26115, Mureau Road, Suite A,
          <br />
          Calabasas, CA 91302.
          <br />
          Tax ID: 95-4527848
        </p>
      </div>
      <div className="invoice_bill_ship_wrap">
        <div className="bill_ship_item">
          <div className="bill_ship_item_head fw_bold">Bill To</div>
          <div className="bill_ship_item_body">
            <p>
              {props.userDetails.firstname} {props.userDetails.lastname}
              <br />
              {ccDetails.address &&
                stringBreakLine(ccDetails.address, 20).map(v => (
                  <React.Fragment>
                    {v}
                    <br />
                  </React.Fragment>
                ))}
              {ccDetails.zip}
              {(localStorage.getItem("mirrorId") === "17512dafe820bd24" ||
                localStorage.getItem("mirrorId") === "16f26162e620e5cb") && (
                <React.Fragment>
                  <br />
                  <br />
                  {"VAT ID: PT510113370"}
                </React.Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="bill_ship_item">
          <div className="bill_ship_item_head fw_bold">Ship To</div>
          <div className="bill_ship_item_body">
            <p>
              {props.userDetails.firstname} {props.userDetails.lastname}
              <br />
              {ccDetails.address &&
                stringBreakLine(ccDetails.address, 20).map(v => (
                  <React.Fragment>
                    {v}
                    <br />
                  </React.Fragment>
                ))}
              {ccDetails.zip}
            </p>
          </div>
        </div>
      </div>
      <div className="invoice_transaction_details">
        <div className="invoice_transaction_details_head">
          <div className="td_details fw_bold">Transaction Details</div>
          <div className="td_description fw_bold">Description</div>
          <div className="td_amount fw_bold">Amount Charged</div>
        </div>
        <div className="invoice_transaction_details_body">
          <div className="td_item">
            <div className="td_details">
              <p>
                <span>Date:</span>{" "}
                <span>
                  {billingInfo.transactionDate &&
                    formatDateToMM(billingInfo.transactionDate.split(" ")[0])}
                </span>
              </p>
              <p>
                <span>Card Number:</span>{" "}
                <span>************{billingInfo.cardNumber}</span>
              </p>
            </div>
            <div className="td_description">
              <p>
                <span>Email:</span>{" "}
                <span>
                  {props.userDetails.emailid &&
                    stringBreakLine(props.userDetails.emailid, 40).map(v => (
                      <React.Fragment>
                        {v}
                        <br />
                      </React.Fragment>
                    ))}
                </span>
              </p>
              {first ? (
                <p>
                  <span>Current Plan:</span>{" "}
                  <span>{props.plan.description}</span>
                </p>
              ) : (
                ""
              )}
              <p>
                <span>Comments:</span> <span>{billingInfo.comments}</span>
              </p>
            </div>
            <div className="td_amount">${billingInfo.transactionAmount}</div>
          </div>
        </div>
        <div className="invoice_transaction_details_foot">
          <div className="td_foot_thanks">We appreciate your business.</div>
          <div className="td_foot_amount">
            <span className="fw_bold">Total </span>
            <span> ${billingInfo.transactionAmount}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userDetails: state.account.userDetails,
    plan: state.account.plan,
    plans: state.common.plans
  };
}

export default withRouter(connect(mapStateToProps)(Invoice));
